import React from "react";
import { fadeInAnimation } from "../animation/motionAnimation";
import Underline from "../../admin/pages/dashboard/Underline";
import { motion } from "motion/react";
const SubHeadingText = ({ children }) => {
  return (
    <div>
      <div className="overflow-hidden mb-0.5">
        <motion.h2
          // variants={textAnimation}
          // initial="initial"
          // animate="animate"
          {...fadeInAnimation}
          className="text-3xl font-bold"
        >
          {children}
        </motion.h2>
      </div>
      <Underline />
    </div>
  );
};

export default SubHeadingText;
